export default __webpack_public_path__ + "img/2d3fb69af8c97dbe510e5c74aaa084a2.png";